import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core'
import { NgClass, NgStyle, NgTemplateOutlet, PercentPipe } from '@angular/common'
import { ResponsiveComponent } from '@nx-superprep/shared'
import { StudySetting, Choice } from '@nx-superprep/backend/firebase'

import { log } from '@nx-superprep/utils';
import { StudyPhase } from '@nx-superprep/backend/firebase';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { ToolbarType } from './toolbar-type'

@Component({
  selector: 'gameplay-toolbar',
  standalone: true,
  templateUrl: './gameplay-toolbar.component.html',
  styleUrls: ['./gameplay-toolbar.component.scss'],
  queries: {
    "dropdown": new ViewChild("dropdown"),
  },
  imports: [
    NgClass,
    NgStyle,
    NgTemplateOutlet,
    FormsModule,
    PercentPipe,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    ProgressbarModule,
    BsDropdownModule,
  ],
})
export class GameplayToolbarComponent extends ResponsiveComponent implements OnInit, OnDestroy {
  @Input() toolbar: ToolbarType = {pause:true, progress:true, volume:true}
  @Input() setting!: StudySetting
  @Input() didAnswer = false
  @Input() progress = 0
  @Input() phase: StudyPhase = StudyPhase.Review
  @Input() hasAudio = false
  @Input() isAutoplay = false
  @Output() selected = new EventEmitter<Choice>()
  @Output() action = new EventEmitter<string>()

  @HostListener('window:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    switch (event.key) {
      case 'ArrowUp': this.volume += 0.1; break;
      case 'ArrowDown': this.volume -= 0.1; break;
    }
  }

  get isStudy() { return this.toolbar.pause && !this.toolbar.home }

  private _buttons = [
    {
      fontIcon: "info_circle",
      class: () => `${this.iconClass} text-info`,
      tooltip: () => 'infos',
      action: () => this.openInfos(),
      visible: () => Boolean(this.toolbar.editor || this.toolbar.debug)
    },
    {
      fontIcon: "check_circle",
      class: () => `${this.iconClass} text-success`,
      tooltip: () => 'force answer right',
      action: () => this.answer(true),
      visible: () => Boolean(this.toolbar.debug)
    },
    {
      fontIcon: "cancel",
      class: () => `${this.iconClass} text-danger`,
      tooltip: () => 'force answer wrong',
      action: () => this.answer(false),
      visible: () => Boolean(this.toolbar.debug)
    },
    {
      fontIcon: "help",
      class: () => `${this.iconClass} text-secondary`,
      tooltip: () => 'force answer random',
      action: () => this.answer(),
      visible: () => false
    },
    {
      fontIcon: "play_circle",
      class: () => `${this.iconClass} ${this.isAutoplay ? 'text-danger' : ''}`,
      tooltip: () => (this.isAutoplay ? 'pause' : 'autoplay') + (this.phase ? ' ' + this.phase + ' phase' : ''),
      action: () => this.complete(),
      visible: () => Boolean(this.toolbar.debug)
    },
    {
      fontIcon: "restart_alt",
      class: () => `${this.iconClass} text-info`,
      tooltip: () => 'force daily reset',
      action: () => this.dailyReset(),
      visible: () => false
    },
  ]

  get buttons() {
    return this._buttons.filter(b => b.visible())
  }

  iconClass = ''//"fa-xl fa-fw"

  set volume(value: number) {
    Howler.volume(Math.max(0, Math.min(1, value)))
  }
  get volume() {
    return Howler.volume()
  }

  isCollapsed = true

  get volumeIcon() { return this.volume > 0 ? 'volume_up' : 'volume_mute' }
  get volumeColor() { return this.volume > 0 ? 'black' : 'red' }
  get volumeAnimate() { return this.volume === 0 && this.hasAudio }
  get volumeClass() { return `${this.iconClass} ${this.volume === 0?'muted':''} ${this.volumeAnimate?'animated':''}` }

  onExit() {
    //log.debug(`home`)
    this.action.emit('home')
  }
  openInfos() {
    //log.debug(`open infos`)
    this.action.emit('openInfos')
  }
  answer(isAnswer?: boolean) {
    //log.debug(`answer ${!!isAnswer}`)
    this.action.emit(`answer ${isAnswer}`)
  }
  complete() {
    //log.debug(`complete`)
    this.isAutoplay = !this.isAutoplay
    this.action.emit('complete')
  }
  dailyReset() {
    //log.debug(`daily reset`)
    this.action.emit('dailyReset')
  }
  openSettings() {
    //log.debug(`open settings`)
    this.action.emit('openSettings')
  }

  onSelect(choice: Choice): void {
    this.selected.emit(choice)
  }

  override ngOnDestroy(): void {
    log.trace('toolbar destroy')
  }

  override ngOnInit() {
    super.ngOnInit()
    log.trace('toolbar init')
  }
}
